import React from 'react'
import Timer from '@bt-react/components/Timer'
import Countdown from '@bt-react/components/Countdown'
import componentStyles from './GigStatus.module.scss'
import styles from '@bt-react/styles'
import classnames from 'classnames'
import { status } from '@bt-react/constants'
import includes from 'lodash/includes'
import { GigStatusProps } from './types'

class Status extends React.Component<GigStatusProps> {

  isUpcoming = () => includes([status.UPCOMING, status.T_MINUS_30, status.LIVE_ENABLED, status.PRE_ROLL_INTERSTITIAL,
    status.GOING_LIVE, status.RESCHEDULED], this.props.status)
  isLive = () => includes([status.LIVE, status.OVERRUN], this.props.status)
  isEnding = () => includes([status.ENDING_LIVE], this.props.status)
  isComplete = () => includes([status.POST_ROLL_INTERSTITIAL, status.CANCELLED, status.COMPLETE], this.props.status)

  getDisplayText = () => {

    if (this.isUpcoming()) return 'Starting in:'
    return ''

  }

  liveLabel = () =>
    <>
      <div className={componentStyles['centerContent']}>
        <span
          className={`${componentStyles[`gigStatus__live-light`]} ${styles[`badge-danger`]}`}
        />
      </div>
      <div className={componentStyles['centerContent']}>
        <span data-bdd='live-label'
          className={classnames(componentStyles[`gigStatus__live-label`],
            styles[`badge-danger`],
            componentStyles['centerContent'])}>
          LIVE
        </span>
      </div>
    </>

  render () {

    const countdownText = this.getDisplayText()
    const statusClasses = classnames(componentStyles['gigStatus'], {
      [componentStyles['--live']]: this.isLive()
    })

    if (
      !this.props.date ||
      this.isEnding() ||
      this.isComplete()
    ) return <div className={statusClasses} />

    return <div className={statusClasses}>
      {
        this.isLive() && this.liveLabel()
      }
      {
        !this.isLive() && !this.isEnding() &&
        <Countdown
          date={this.props.date}
          countdownText={countdownText}
          className={componentStyles[`gigStatus__timer`]}
          allowMinus={true}
          color={this.props.invert ? 'white' : 'black'}
          overrunColor={`orange`}
        />
      }
      {
        this.isLive() &&
        <Timer
          date={this.props.date}
          className={componentStyles[`gigStatus__timer`]}
          color={this.props.invert ? 'white' : 'black'}
          overrunColor={`orange`}
          duration={this.props.duration}
        />
      }

    </div>

  }

}

export default Status
